import axios from "axios";
// import store from "../store";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // baseURL: "http://192.168.4.30:4000/front/api/",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    accept: "*/*",
    "X-Host": "solis",
  },
});

export default axiosInstance;
